
import { Component, Vue, Prop } from "vue-property-decorator";
import Avatar from "@/components/Avatar.vue";
import { getCourseDetail } from "@/apis/about";
import { formatUpyunUrl } from "@/utils";
import { getCourseJsonLd, getFaqJsonLd, injectJsonLd } from "@/utils/seo";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import ApplyFormDialog from "@/components/ApplyFormDialog.vue";
import FaqSection from "@/components/FaqSection.vue";
@Component({
  components: { Avatar, Breadcrumb, ApplyFormDialog, FaqSection }
})
export default class course extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  course_id = "" as any;
  detail = {} as any;
  show: boolean = false;

  courseFaqs = [
    {
      question: "光华赋能的课程适合什么类型的企业？",
      answer: "光华赋能课程主要面向中大型企业的中高层管理者、创始人及事业部负责人，覆盖制造业、服务业、互联网、金融等多个行业。课程内容基于BLM科学经营方法论，适合处于战略转型、组织升级、绩效提升阶段的企业。"
    },
    {
      question: "课程报名后可以开发票吗？",
      answer: "可以。光华赋能提供正规增值税专用发票或普通发票，报名成功后可联系课程顾问申请开票，发票内容为'培训费'或'咨询服务费'。"
    },
    {
      question: "课程结束后有后续跟进服务吗？",
      answer: "有。课程结束后提供30天在线答疑服务，学员可通过专属社群向讲师提问。同时，光华赋能提供管理微咨询、咨询陪跑等后续落地服务，帮助企业将课程所学转化为实际经营成果。"
    },
    {
      question: "可以定制企业内训课程吗？",
      answer: "可以。光华赋能提供企业内训定制服务，根据企业的行业特点、发展阶段和具体需求，量身定制课程内容和授课形式。企业内训可在企业现场或光华赋能培训基地进行，具体可联系课程顾问沟通方案。"
    },
    {
      question: "光华赋能的讲师团队背景如何？",
      answer: "光华赋能讲师团队由方永飞等资深经营管理专家组成，均拥有15年以上企业管理实战经验，曾服务过众多知名企业。讲师兼具理论深度和实战经验，课程内容注重可操作性和落地性。"
    }
  ];

  List = [
    { title: "光华商学院", url: "" },
    { title: "公开课", url: "/course" },
    { title: "课程详情", url: "" }
  ];

  endTime() {
    // 同一天
    if (
      this.detail.time_start.substring(0, 10) ==
      this.detail.time_end.substring(0, 10)
    ) {
      return this.detail.time_end.substring(11, 16);
    }
    return this.detail.time_end.substring(5, 16);
  }
  created() {
    // 优先从路径参数获取 id，兼容旧的 query.course_id 参数形式
    this.course_id = (this.$route.params.id || this.$route.query.course_id || "") as string;
    this.getCourseDetail();
  }

  async getCourseDetail() {
    const data = await getCourseDetail({
      origin: 1,
      course_id: this.course_id
    });
    this.detail = data;
    // 注入 Course JSON-LD
    if (data && data.title) {
      injectJsonLd(
        "jsonld-course",
        getCourseJsonLd({
          name: data.title,
          description:
            data.intro && Array.isArray(data.intro)
              ? data.intro
                  .filter((i: any) => i.type === "p")
                  .map((i: any) => i.value)
                  .join(" ")
                  .substring(0, 300)
              : data.title,
          instructor: data.teacher_expand || (data.teacher && data.teacher[0] ? data.teacher[0].name : undefined),
          startDate: data.time_start ? data.time_start.substring(0, 10) : undefined,
          endDate: data.time_end ? data.time_end.substring(0, 10) : undefined,
          image: data.image ? formatUpyunUrl(data.image) : undefined
        })
      );
      // 注入 FAQPage JSON-LD
      injectJsonLd("jsonld-course-faq", getFaqJsonLd(this.courseFaqs));
    }
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
